import React, { memo } from 'react';
import { Box, Menu, MenuItem, MenuProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PenIcon, TrashIcon } from '~/assets/icons';

type MenuOptionProps = MenuProps & {
  handleEditItem: () => void;
  handleDeleteItem: () => void;
  enableEdit?: boolean;
  enableDelete?: boolean;
};

const MenuOption = (props: MenuOptionProps) => {
  const { handleEditItem, handleDeleteItem, enableEdit = true, enableDelete = true, ...restProps } = props;

  const { t } = useTranslation('admin/common');

  return (
    <Menu
      id={`franchise-option-menu`}
      className='flex w-full'
      keepMounted
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...restProps}
    >
      {enableEdit && (
        <MenuItem onClick={handleEditItem}>
          <Box className='flex flex-row items-center p-[6px] w-[169px]'>
            <PenIcon className='w-[14px] h-[14px]' />
            <Box className='ml-[6px] text-[14px]/[16.8px] font-normal text-[#5A6385]'>{t('edit')}</Box>
          </Box>
        </MenuItem>
      )}

      {enableDelete && (
        <MenuItem onClick={handleDeleteItem} className='mt-[10px] bg-[#FFF0F0]' id='danger'>
          <Box className='flex flex-row items-center p-[6px] w-[169px] '>
            <TrashIcon className='w-[16px] h-[16px]' stroke='#FC0000' fill='#FC0000' />
            <Box className='ml-[6px] text-[14px]/[16.8px] font-normal text-[#FC0000]'>{t('delete')}</Box>
          </Box>
        </MenuItem>
      )}
    </Menu>
  );
};

export default memo(MenuOption);
